/**
 * Renders a form for adding an image
 */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import i18n from '../../../../../shared/locales/no.json';
import FileUpload from '../../../../components/fileUpload/FileUpload';
import isNumber from 'isnumber';
import cx from 'classnames';

export default class extends PureComponent {
    static propTypes = {
        errorMsg: PropTypes.string,
        profileId: PropTypes.number.isRequired,
        onUpload: PropTypes.func.isRequired,
    };

    state = {
        inProgress: false,
    };

    startProgress() {
        this.setState({ inProgress: true });
    }

    stopProgress() {
        this.setState({ inProgress: false });
    }

    // splits arguments and delegates to uploadFiles,
    // for simpler testing
    filesSubmitted(files) {
        this.uploadFiles(files, Object.keys(files).filter(isNumber));
    }

    uploadFiles(fileList, fileKeys) {
        // TODO: handle this further up
        this.startProgress();

        const promises = fileKeys.map((f) =>
            this.props.onUpload(this.props.profileId, fileList[f])
        );

        // TODO: handle this further up
        Promise.all(promises)
            .then(this.stopProgress.bind(this))
            .catch(this.stopProgress.bind(this));
    }

    render() {
        const { errorMsg } = this.props;

        const classes = cx([errorMsg && 'invalid', 'r-margin']);

        return (
            <div>
                <p>{i18n.images.choose}</p>
                <div className={classes}>
                    <FileUpload
                        classes="button button--small u-mt8"
                        inProgress={this.state.inProgress}
                        multiple
                        onFileSubmit={this.filesSubmitted.bind(this)}
                    >
                        {i18n.images.chooseBtn}
                    </FileUpload>
                    <span className="help-inline">{errorMsg}</span>
                </div>
            </div>
        );
    }
}
